// Components==============
import { faLightbulb } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReadAnswerType } from 'components/Exercises/AudioTypingExercise/AudioTypingExercise';
import React from 'react';
import { useAudio } from 'utilities/useAudio';
import Circle from '../Circle/Circle';
import './ReadAnswer.module.scss';
// =========================

export default function ReadAnswer({ answer }: { answer: ReadAnswerType }) {
    const { play } = useAudio({
        text: typeof answer === 'string' ? answer : undefined,
        audioFile: typeof answer === 'object' ? answer.file : undefined,
    });

    return (
        <Circle background="#fcb922" onClick={() => play()}>
            <FontAwesomeIcon icon={faLightbulb} />
        </Circle>
    );
}
